import React from "react";
import "./Games.scss";

interface Props {
  type: string;
  rank?: number;
  status: string;
  logo: string;
  name: string;
  href?: string;
  index: number;
  isDisabled?: boolean;
}

const newCard = () => {
  return <div></div>;
};

const Games: React.FunctionComponent<Props> = (props) => {
  const rank = () => {
    if (props.type === "ranked") {
      return (
        <div className="rankDiv">
          {props.name !== "DALALBULL" ? 
            <div className="RankValue">{["EXAGON"].includes(props.name) ? "SCORE" : "RANK"} {props.rank}</div>
            : null
          }
        </div>
      );
    }
    // return <div className="PlayNow">{props.status}</div>;
  };

  return (
    <a style={{ textDecoration: 'none' }} href={props.href}>
      <div className="gamecell__container">
        <div
          className={`games position-relative ${props.isDisabled ? "disabled-game bg-5" : `bg-${props.index}`
            }`}
        >
          <div className="gameCell">

            <div className="gamecell__box2">

              <div className={"pic-box"}>
                <img src={props.logo} alt="" className="pic" />



              </div>
              <div className={"title"}>{props.name}</div>

            </div>


            <div className="Rankdetail">


              <div className="rank__container">

                <div className=""> {rank()} </div>

                <div
                  // className={"play-button"}
                  className={`${props.status == "Play Now" ? "play-button" : "play-button2"}`}


                >{props.status}</div></div>




            </div>
          </div>

        </div>
      </div>
    </a>
  );
};

export default Games;
